import React from "react";

interface Props {
  disabled: boolean;
}

const EyeOff = ({ disabled }: Props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1072_18195)">
        <path
          d="M11.9601 11.9601C10.8205 12.8288 9.43282 13.31 8.00008 13.3334C3.33341 13.3334 0.666748 8.0001 0.666748 8.0001C1.49601 6.45469 2.64617 5.1045 4.04008 4.0401M6.60008 2.82676C7.05897 2.71935 7.52879 2.66566 8.00008 2.66676C12.6667 2.66676 15.3334 8.0001 15.3334 8.0001C14.9287 8.75717 14.4461 9.46992 13.8934 10.1268M9.41341 9.41343C9.23032 9.60993 9.00951 9.76753 8.76418 9.87685C8.51885 9.98616 8.25402 10.0449 7.98548 10.0497C7.71693 10.0544 7.45019 10.005 7.20115 9.90442C6.95212 9.80384 6.7259 9.65412 6.53598 9.4642C6.34606 9.27428 6.19634 9.04806 6.09575 8.79902C5.99516 8.54999 5.94577 8.28325 5.9505 8.0147C5.95524 7.74616 6.01402 7.48133 6.12333 7.236C6.23264 6.99066 6.39025 6.76986 6.58675 6.58676"
          stroke={disabled ? "#D0D5DD" : "#1D2939"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666748 0.666748L15.3334 15.3334"
          stroke={disabled ? "#D0D5DD" : "#1D2939"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1072_18195">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeOff;
